module.exports = __webpack_public_path__ + "static/quiz_question_girl_boy_true_bg-aadc8e7aa6826fc2fe71d93504fd9110.svg";